import React from "react";
import classNames from "classnames/bind";
import styles from "../PrimaryCard/PrimaryCard.module.scss";
import type { CardConfigType } from "../CardGrid/types";

const cx = classNames.bind(styles);

type LastUpdateType = {
  /** last update of the schema */
  lastUpdate?: string;
  cardConfig?: CardConfigType;
};

const LastUpdated = ({
  lastUpdate = "",
  cardConfig = {
    hasGreyBar: true,
  },
}: LastUpdateType) => {
  return (
    <>
      <p className={cx("author")}>{lastUpdate}</p>
      {cardConfig.hasGreyBar ? (
        <div className={cx("pillsContainerClosed")} />
      ) : null}
    </>
  );
};

export default LastUpdated;
